import React, { useEffect } from 'react';

import { ConversationAssistantNavBarButton } from '@confluence/conversation-assistant/entry-points/navBarButton.ts';
import { RovoEntitlementSetter } from '@confluence/conversation-assistant/entry-points/conversation-assistant-entitlement.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { fg } from '@confluence/feature-gating';
import { expValEquals } from '@confluence/feature-experiments';

export const RovoButton = () => {
	const {
		isLoggedIn,
		isRovoEnabled: isRovoEnabledSessionData,
		isRovoLLMEnabled,
		accessStatus,
	} = useSessionData();

	const shouldShowRovo = fg('rovo_use_rovo_llm_enabled_check')
		? isRovoLLMEnabled
		: isRovoEnabledSessionData;

	const isRovoEnabled =
		shouldShowRovo && isLoggedIn && accessStatus !== AccessStatus.EXTERNAL_COLLABORATOR_ACCESS;

	useEffect(() => {
		if (isRovoEnabled) {
			expValEquals('cc-aifc-databases-experiment', 'isEnabled', true);
		}
	}, [isRovoEnabled]);

	return (
		<>
			{isRovoEnabled && <ConversationAssistantNavBarButton />}
			<RovoEntitlementSetter isRovoEnabled={isRovoEnabled} />
		</>
	);
};
